import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

export interface ConsoleOrderRequest {
    category: string;
    limit: string;
    page: number;
    user_id: string;
    from_date: string; // YYYY-MM-DD
    to_date: string; // YYYY-MM-DD
    serial_number: string;
    order_state: string; // "대기" | "완료";
    delivery_type: string; // "편도" | "왕복" | "경유";
    car_type: string; // "오토바이" | "다마스" | "라보" | "벤" | "지하철" | "트럭";
    departure_dong_name: string;
    payment_type: string; // "선불" | "착불" | "신용" | "송금" | "수금";
    destination_dong_name: string;
}
export type DataListProps = {
    list_no: number;
    w_date: string;
    c_name: string;
    c_dept_name: string;
    kind: string;
    s_start: string;
    start_dong: string;
    start_sido: string;
    start_gugun: string;
    start_location: string;
    pay_gbn: string;
    doc: string;
    sfast: string;
    item_type: string;
    order_state: string;
    dtime: string;
    dest_charge: string;
    dest_dong: string;
    dest_sido: string;
    dest_gugun: string;
    dest_location: string;
};

export interface ResponseData {
    current_page: number;
    end_page: number;
    last_page: number;
    limit: number;
    max_page: number;
    start_page: number;
    total_count: number;
    data_list: DataListProps[];
}

export const useGetConsoleExpressOrder = (data: ConsoleOrderRequest | null): UseQueryResult<ResponseData, Error> => {
    return useQuery({
        queryKey: ["useGetConsoleExpressOrder", data],
        queryFn: async () => {
            if (!data) throw new Error("Invalid request data");
            let url = enum_api_uri.get_console_express_order;
            const response = await axiosInstance.get(url, {
                params: {
                    category: data.category,
                    limit: data.limit,
                    page: data.page,
                    user_id: data.user_id,
                    from_date: data.from_date,
                    to_date: data.to_date,
                    serial_number: data.serial_number,
                    order_state: data.order_state,
                    delivery_type: data.delivery_type,
                    car_type: data.car_type,
                    departure_dong_name: data.departure_dong_name,
                    payment_type: data.payment_type,
                    destination_dong_name: data.destination_dong_name,
                },
            });
            return response.data.data;
        },
        enabled: !!data,
    });
};
